// ============================================
// Path: /frontend/src/pages/HomePage.jsx
// Purpose: Landing page with hero, featured listings, and categories
// ============================================

import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { HeroSection } from '../components/HeroSection';
import { FeaturedListings } from '../components/FeaturedListings';
import { CategoryGridCard } from '../components/CategoryGridCard';
import { Car, Home, Handshake } from 'lucide-react';

export default function HomePage() {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow">
        <HeroSection />

        {/* Category Cards */}
        <section className="py-6 bg-muted/40">
          <div className="container">
            <h2 className="text-base sm:text-lg md:text-xl font-normal text-center mb-4">
              Browse by Category
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-4xl mx-auto">
              <CategoryGridCard
                name="Vehicles"
                href="/vehicles"
                image="/images/car-category.png"
              />
              <CategoryGridCard
                name="Properties"
                href="/properties"
                image="/images/house-category.png"
              />
              <CategoryGridCard
                name="Joint Ventures"
                href="/joint-ventures"
                image="/images/download (1).jpg"
              />
            </div>
          </div>
        </section>

        <FeaturedListings />
      </main>
      <Footer />
    </div>
  );
}